import React from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import ISO from './images/ISO_Paperlive.jpeg';

export default function Awards() {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <React.Fragment>
        <div style={{margin: "3rem 0 0 4%"}}>
            <span className={isSmallScreen ? "only-heading-sm" :"only-heading"}>Awards &</span>
            <span className={isSmallScreen ? "gradient-heading-sm" : "gradient-heading"}> Recognition</span>
            <div style={{width: "99%", margin: "3rem 0 3rem 0"}}>
                <img src={ISO} height={"500px"} style={{margin:"auto", display: "block"}}/>
            </div>
        </div>
    </React.Fragment>
  );
}